import toastr from 'toastr';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as UserUtilities from '../../../../HelperMethods/UserUtilities';
import * as TaskUtilities from '../../../../HelperMethods/TaskUtilities';
import ApiService from '../../../../service/apiService';
import { setTaskKpis } from './reducers';

export const TASK_CARD_ERROR_VALUE = 'TASK_CARD_ERROR_VALUE';
export const TASK_CARD_VALUE_LOADING = 'TASK_CARD_VALUE_LOADING';

function ifDistanceDurationFieldsAreNeeded(task, allTasks, allUsers) {
  const allAssigneeIds = task.assigneeIds && task.assigneeIds.filter((a) => !a.isDeleted);
  const assigneeId = allAssigneeIds && allAssigneeIds[0] && allAssigneeIds[0].assigneeId;
  if (!assigneeId) return { flag: false, assigneeId: null };
  const user = allUsers.find((u) => u.id === assigneeId);
  if (!user) {
    console.error('did not find user id ', assigneeId);
    return { flag: false, assigneeId: null };
  }
  const userWholeDay = UserUtilities.getWholeDayForAssignee(user, new Date());
  if (!userWholeDay) {
    console.error(`did not find shift for user id: ${assigneeId}`);
    return { flag: false, assigneeId: null };
  }

  const tasksAssignedToUserForCurrentDay = allTasks.filter(
    (t) =>
      TaskUtilities.doesTaskBelongToAssigneeId(t, assigneeId) &&
      moment(t.startTime).isSameOrBefore(moment(userWholeDay.endDate)) &&
      moment(t.startTime).isSameOrAfter(moment(userWholeDay.startDate)) &&
      !TaskUtilities.isTaskParent(t) &&
      !TaskUtilities.isTaskSeriesOfRecurrence(t)
  );
  const userCurrentMinSeq = _.min(
    tasksAssignedToUserForCurrentDay.map((t) => TaskUtilities.getSequenceNumberForTaskAndAssigneeId(t, assigneeId))
  );
  const currentTaskSeq = TaskUtilities.getSequenceNumberForTaskAndAssigneeId(task, assigneeId);
  return { flag: currentTaskSeq === userCurrentMinSeq, assigneeId };
}

function setLoadingTaskKpis() {
  return (dispatch) => {
    dispatch(setTaskKpis(TASK_CARD_VALUE_LOADING, TASK_CARD_VALUE_LOADING));
  };
}

export function setTaskDistanceAndDurationKpis(task, allTasks, allUsers) {
  return async (dispatch) => {
    const { flag: isDistanceDurationFieldNeeded, assigneeId } = ifDistanceDurationFieldsAreNeeded(
      task,
      allTasks,
      allUsers
    );
    dispatch(setTaskKpis(null, null));
    if (isDistanceDurationFieldNeeded) {
      try {
        const stopId = _.get(task, 'asset.stop.id');
        if (stopId && assigneeId) {
          dispatch(setLoadingTaskKpis());
          const output = await ApiService.getStopDurationFromUserLocation(stopId, assigneeId);
          const outputObject = JSON.parse(output);
          const { distance, duration } = outputObject;
          dispatch(setTaskKpis(distance, duration));
        } else {
          const message = stopId ? 'Assignee Id could not be obtained' : 'Stop Id could not be extracted';
          // eslint-disable-next-line no-throw-literal
          throw { success: false, message };
        }
      } catch (e) {
        const message = e instanceof Error ? "Location of Assignee couldn't be fetched" : e.message;
        toastr.error(message);
        dispatch(setTaskKpis(TASK_CARD_ERROR_VALUE, TASK_CARD_ERROR_VALUE));
      }
    }
  };
}
